import { CheckCircleFilled, ExclamationCircleFilled, PrinterOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, DatePickerProps, Flex, Form, Image, Row, Select, Table, Tooltip, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Filtro } from "../../../components/filtroComponent/filtro";
import FiltroComponent from "../../../components/filtroComponent/filtroComponent";
import TableComponent from "../../../components/table/tableComponent";
import { DetalhesFiltrosModel } from "../../../models/detalhesFiltrosModel";
import { EmpresaModel } from "../../../models/empresa/empresaModel";
import { BuscaRelatorioContaBancariaModel } from "../../../models/relatorio/BuscaRelatorioContaBancariaModel";
import { RelatorioContaBancariaVM } from "../../../models/relatorio/RelatorioContaBancariaVM";
import { setTitle } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { resetRelatorioContaBancaria, setBuscaRelatorioContaBancaria } from "../../../redux/slices/relatorio/relatorioSlice";
import { buscarEmpresa } from "../../../services/empresaService";
import { gerarRelatorioContaBancaria } from "../../../services/relatorioService";
import { currencyBRL } from "../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import "./style/index.scss";

const columns: ColumnsType<RelatorioContaBancariaVM> = [
  {
    title: "Denominação",
    dataIndex: "denominacaoContaBancaria",
    render: (_, record) => (
      <Typography.Text style={{ width: 200 }} ellipsis={{ tooltip: record.denominacaoContaBancaria }}>
        {record.denominacaoContaBancaria}
      </Typography.Text>
    ),
  },
  {
    title: "Saldo Inicial",
    dataIndex: "saldoInicial",
    align: "right",
    width: 150,
    render: (_, record) => <p style={{ color: record.saldoInicial < 0 ? "red" : "blue", marginBottom: "0px" }}>{record.saldoInicial && currencyBRL(record.saldoInicial)}</p>,
  },
  {
    title: "Crédito",
    dataIndex: "credito",
    align: "right",
    width: 150,
    render: (_, record) => <p style={{ color: "blue", marginBottom: "0px" }}>{record.credito && currencyBRL(record.credito)}</p>,
  },
  {
    title: "Débito",
    dataIndex: "debito",
    align: "right",
    width: 150,
    render: (_, record) => <p style={{ color: "red", marginBottom: "0px" }}>{record.debito && currencyBRL(record.debito)}</p>,
  },
  {
    title: "Saldo Final",
    dataIndex: "saldoFinal",
    align: "right",
    width: 150,
    render: (_, record) => <p style={{ color: record.saldoFinal < 0 ? "red" : "blue", marginBottom: "0px" }}>{record.saldoFinal && currencyBRL(record.saldoFinal)}</p>,
  },
];

interface RelatorioHtmlProps {
  dataAgora: string;
  filtrosImpressao: FiltrosImpresso | undefined;
  list: RelatorioContaBancariaVM[];
  busca: BuscaRelatorioContaBancariaModel;
  filtros: DetalhesFiltrosModel[];
  somatorio: somatorioContas;
}

const RelatorioHtml = React.forwardRef<HTMLDivElement, RelatorioHtmlProps>(({ dataAgora, filtrosImpressao, list, busca, filtros, somatorio }, ref) => (
  <div ref={ref} className="relatorios-html-format">
    <div className="rel-cabecalho">
      <div className="rel-titulo">
        <h2>
          <strong>Contas Bancárias</strong>
        </h2>
        <p>Gerado em {dataAgora}</p>
      </div>
      <hr />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p>{"Empresa: " + filtrosImpressao?.empresa}</p>
        <p>
          {busca.dataInicio !== null && busca.dataFim !== null ? "Período: " + dayjs(busca.dataInicio).format("DD/MM/YYYY") + " " + "até " + dayjs(busca.dataFim).format("DD/MM/YYYY") + ";" : ""}
          {busca.dataInicio !== null && busca.dataFim === null ? "Data do Sorteio: " + dayjs(busca.dataInicio).format("DD/MM/YYYY") : ""}
        </p>
      </div>
      {filtros.length > 0 && (
        <div style={{ fontSize: "12px", marginTop: "5px", marginBottom: "10px" }}>
          <div style={{ fontWeight: "bold" }}>Filtros avançados:</div>
          {filtros.map((a: DetalhesFiltrosModel, index: any) => (
            <div key={index}>
              {index + 1 + ". " + a.campo} <strong style={{ fontStyle: "italic" }}>{a.operador}</strong> {a.campo === "Valor" ? currencyBRL(a.valor) : a.valor}
              {a.valor2 && " e ".concat(currencyBRL(a.valor2))}
            </div>
          ))}
        </div>
      )}
    </div>
    <div className="rel-detalhes">
      <table className="tb-dados">
        <thead>
          <tr className="header-table">
            <th className="ht-left">Denominação</th>
            <th className="ht-right">Saldo inicial</th>
            <th className="ht-right">Crédito</th>
            <th className="ht-right">Débito</th>
            <th className="ht-right">Saldo final</th>
          </tr>
        </thead>
        <tbody className="body-table">
          {list.map((t) => (
            <React.Fragment key={t.idContaBancaria}>
              <tr>
                <td className="ht-left">{t.denominacaoContaBancaria}</td>
                <td className="ht-right">{currencyBRL(t.saldoInicial)}</td>
                <td className="ht-right">{currencyBRL(t.credito)}</td>
                <td className="ht-right">{currencyBRL(t.debito)}</td>
                <td className="ht-right">{currencyBRL(t.saldoFinal)}</td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
        <tfoot className="footer-table">
          <tr>
            <td className="ht-left">SALDO DO PERÍODO:</td>
            <td className="ht-right">{currencyBRL(somatorio.saldoInicial)}</td>
            <td className="ht-right">{currencyBRL(somatorio.credito)}</td>
            <td className="ht-right">{currencyBRL(somatorio.debito)}</td>
            <td className="ht-right">{currencyBRL(somatorio.saldoFinal)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
));

interface somatorioContas {
  saldoInicial: number;
  credito: number;
  debito: number;
  saldoFinal: number;
}

interface FiltrosImpresso {
  empresa?: string | undefined;
  periodo?: string;
}

const tipoDataOptions = [
  { label: "Sorteio", value: "SORT" },
  { label: "Lançamento", value: "LANC" },
];

const ContaBancariaRelatorio = () => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);
  const configuracoesState = useAppSelector((state) => state.configuracoes);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<any>();
  const [openFiltros, setOpenFiltros] = useState<boolean>(false);
  const [idEmpresa, setIdEmpresa] = useState<number | null>(null);

  const checkboxOptions = [
    { label: "Não realizado", value: "Não realizado" },
    { label: "Realizado", value: "Realizado" },
    { label: "Vencido", value: "Vencido" },
  ];

  //relatorio para impressão
  const dataAgora = dayjs().format("DD/MM/YYYY [às] HH:mm");
  const [filtrosImpressao, setFiltroImpressao] = useState<FiltrosImpresso>();

  useEffect(() => {
    form.setFieldsValue({
      tipoDataFiltro: relatorioState.buscaContaBancaria.tipoDataFiltro,
      dateInicio: relatorioState.buscaContaBancaria.dataInicio && dayjs(relatorioState.buscaContaBancaria.dataInicio),
      dateFim: relatorioState.buscaContaBancaria.dataFim && dayjs(relatorioState.buscaContaBancaria.dataFim),
      status: ["Não realizado", "Realizado", "Vencido"],
    });
    dispatch(setTitle("RELATÓRIO DE CONTAS BANCÁRIAS"));
    dispatch(buscarEmpresa(empresaState.busca));
    if (persistedState.user.empresa !== null) {
      let idEmpresa = parseInt(persistedState.user.empresa.idEmpresa.toString());
      onChangeEmpresaPerfil(idEmpresa);
      setIdEmpresa(idEmpresa);
    }
  }, []);

  const onChangeDateInicio = (value: DatePickerProps["value"], _dateString: string | string[]) => {
    const busca: BuscaRelatorioContaBancariaModel = { ...relatorioState.buscaContaBancaria, dataInicio: dayjs(value).toDate() };
    dispatch(setBuscaRelatorioContaBancaria(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], _dateString: string | string[]) => {
    const busca: BuscaRelatorioContaBancariaModel = { ...relatorioState.buscaContaBancaria, dataFim: dayjs(value).toDate() };
    dispatch(setBuscaRelatorioContaBancaria(busca));
  };

  const onChangeEmpresa = (value: number) => {
    setIdEmpresa(value);
    const searchEmpresa = empresaState.list.find((empresa) => empresa.id === value);
    setFiltroImpressao({ ...filtrosImpressao, empresa: searchEmpresa?.apelido });
    dispatch(setBuscaRelatorioContaBancaria({ ...relatorioState.buscaContaBancaria, idEmpresa: value }));
  };

  const onChangeEmpresaPerfil = (value: number) => {
    const searchEmpresa = empresaState.list.find((empresa) => empresa.id === value);
    setFiltroImpressao({ ...filtrosImpressao, empresa: searchEmpresa?.apelido });
    dispatch(setBuscaRelatorioContaBancaria({ ...relatorioState.buscaContaBancaria, idEmpresa: value }));
  };

  const onChangeCheckbox = (list: any[]) => {
    const busca: BuscaRelatorioContaBancariaModel = {
      ...relatorioState.buscaContaBancaria,
      naoRealizado: list.includes("Não realizado"),
      realizado: list.includes("Realizado"),
      vencido: list.includes("Vencido"),
    };
    dispatch(setBuscaRelatorioContaBancaria(busca));
  };

  const onChangeMostrarFiltros = async () => {
    try {
      await form.validateFields();
      setOpenFiltros(!openFiltros);
    } catch (e) {}
  };

  const onChangeTipoData = (value: string) => {
    let busca: BuscaRelatorioContaBancariaModel = { ...relatorioState.buscaContaBancaria, tipoDataFiltro: value };

    dispatch(resetRelatorioContaBancaria());
    dispatch(setBuscaRelatorioContaBancaria(busca));
  };

  const atualizar = () => {
    dispatch(gerarRelatorioContaBancaria(relatorioState.buscaContaBancaria));
  };

  const somatorio = useMemo<somatorioContas>(
    () =>
      relatorioState.listContaBancaria.reduce(
        (acumulador, conta) => {
          acumulador.saldoInicial += conta.saldoInicial || 0;
          acumulador.credito += conta.credito || 0;
          acumulador.debito += conta.debito || 0;
          acumulador.saldoFinal += conta.saldoFinal || 0;
          return acumulador;
        },
        { saldoInicial: 0, credito: 0, debito: 0, saldoFinal: 0 },
      ),
    [relatorioState.listContaBancaria],
  );

  const relatorioContaBancaria = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => relatorioContaBancaria.current,
  });

  return (
    <Flex vertical>
      <Filtro abrir={openFiltros} funcao={onChangeMostrarFiltros} />
      {openFiltros && <FiltroComponent idEmpresa={idEmpresa ? idEmpresa : relatorioState.buscaContaBancaria.idEmpresa} origem={"relatorioLancamentoBancario"} />}
      <Form form={form} layout="vertical" style={openFiltros ? { marginTop: "0px" } : { marginTop: "14px" }}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma empresa",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Tipo de data"
                name="tipoDataFiltro"
                rules={[
                  {
                    required: true,
                    message: "Selecione um tipo de data para o filtro",
                  },
                ]}
              >
                <Select onChange={onChangeTipoData} style={{ width: 150 }} options={tipoDataOptions} />
              </Form.Item>
              <Form.Item
                label="Data início"
                name="dateInicio"
                rules={[
                  {
                    required: true,
                    message: "Selecione uma data início",
                  },
                ]}
              >
                <DatePicker onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item
                label="Data fim"
                name="dateFim"
                rules={[
                  {
                    required: true,
                    message: "Selecione uma data fim",
                  },
                ]}
              >
                <DatePicker onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item name="botaoImprimir" label=" ">
                <Button icon={<PrinterOutlined />} onClick={handlePrint} disabled={relatorioState.loadingContaBancaria}></Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
        <Row gutter={8} align="bottom">
          <Col span={24}>
            <Flex>
              <Form.Item label="Status" name="status">
                <Checkbox.Group style={{ width: "100%" }} onChange={onChangeCheckbox}>
                  <CheckCircleFilled size={32} style={{ color: "green" }} />
                  <Checkbox value={checkboxOptions[1].value}>{checkboxOptions[1].label}</Checkbox>
                  <ExclamationCircleFilled style={{ color: "red" }} />
                  <Checkbox value={checkboxOptions[2].value}>{checkboxOptions[2].label}</Checkbox>
                  <ExclamationCircleFilled style={{ color: "orange" }} />
                  <Checkbox value={checkboxOptions[0].value}>{checkboxOptions[0].label}</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        data={relatorioState.listContaBancaria}
        columns={columns}
        loading={relatorioState.loadingContaBancaria}
        rowKey="idContaBancaria"
        tableProps={{
          summary: (pageData: any) =>
            pageData.length > 0 && (
              <Table.Summary.Row className="rowFooterCls">
                <Table.Summary.Cell index={0}>SALDO DO PERÍODO:</Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <span style={{ color: somatorio.saldoInicial > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.saldoInicial)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  <span style={{ color: somatorio.credito > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.credito)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  <span style={{ color: somatorio.debito > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.debito)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right">
                  <span style={{ color: somatorio.saldoFinal > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.saldoFinal)}</span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            ),
        }}
      />
      <div style={{ display: "none" }}>
        <RelatorioHtml
          ref={relatorioContaBancaria}
          dataAgora={dataAgora}
          filtrosImpressao={filtrosImpressao}
          list={relatorioState.listContaBancaria}
          busca={relatorioState.buscaContaBancaria}
          filtros={configuracoesState.filtros}
          somatorio={somatorio}
        />
      </div>
    </Flex>
  );
};

export default ContaBancariaRelatorio;
